import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface EditVehicleSummaryRowProps {
  labelTextId: string;
  originalValue: string;
  newValue: string;
  hasChanged: boolean;
  endAdornment?: React.ReactNode | string;
}

export const EditAutoPaymentMethodSummaryRow = ({
  labelTextId,
  originalValue,
  newValue,
  hasChanged,
  endAdornment,
}: EditVehicleSummaryRowProps) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="flex-start" gridGap={8}>
      <Font className="pr-3" variant="body2" color="textSecondary" style={{ minWidth: '0px', whiteSpace: 'nowrap' }}>
        <Text tId={labelTextId} />:
      </Font>
      <Box
        className="overflow-text-ellipsis"
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        gridGap={6}
        textAlign="right"
        flexWrap={'wrap'}
      >
        {hasChanged ? (
          <>
            <Font variant="body2" strikethrough>
              {originalValue}
            </Font>
            <Font variant="body2" color="title" style={{ fontWeight: 700 }}>
              {newValue}
            </Font>
          </>
        ) : (
          <Font variant="body2" color="title" style={{ fontWeight: 700 }}>
            {newValue}
          </Font>
        )}
        {endAdornment &&
          (typeof endAdornment === 'string' ? (
            <Font variant="body2" color="title" style={{ fontWeight: 700 }}>
              {endAdornment}
            </Font>
          ) : (
            endAdornment
          ))}
      </Box>
    </Box>
  );
};
